export function getPlaceOrderOrigin(state: WtrState) {
  return state?.checkout?.placeOrderOrigin;
}
